// Campus photo for /colleges/temple-university: CC BY 4.0, by Jim.henderson, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACharles_Library_winter_jeh.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/temple-university/; credited under the photo.
const photo = {
    "slug": "temple-university",
    "alt": "Charles Library, a stone and glass building with an arched wooden entrance, at Temple University",
    "src": "/colleges/temple-university/campus-1600.webp",
    "srcSmall": "/colleges/temple-university/campus-800.webp",
    "srcMid": "/colleges/temple-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/temple-university/og.jpg",
    "title": "Charles Library winter jeh",
    "author": "Jim.henderson",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACharles_Library_winter_jeh.jpg",
    "read": "2026-10-02"
};

export default photo;
